import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ResearchDevelopmentConsultancyComponenets/ResearchPageSection/ResearchPageSection.tsx");
